<div class="modal" [dataSelector]="dataSelector">
  <div class="modal__cont" [dataSelector]="dataSelector + '-content'">
    <h1 class="modal__title" [dataSelector]="dataSelector + '-title'">Submit Requests for Review</h1>
    <p class="modal__text" [dataSelector]="dataSelector + '-text'">
      You have {{ data.flaggedFilesCount }} flagged file{{ data.flaggedFilesCount === 1 ? '' : 's' }} that {{ data.flaggedFilesCount === 1 ? "hasn't" : "haven't" }} been replaced.
      Submitting now means {{ data.flaggedFilesCount === 1 ? 'this item' : 'these items' }} may still need follow-up.
      You can go back to review {{ data.flaggedFilesCount === 1 ? 'it' : 'them' }} or continue with submission.
    </p>
    <div class="modal__buttons" [dataSelector]="dataSelector + '-buttons'">
      <button andButton color="default" (click)="onCancel()" [dataSelector]="dataSelector + '-cancel-button'">Cancel</button>
      <button andButton color="primary" type="submit" (click)="onSubmitAnyway()" [dataSelector]="dataSelector + '-submit-button'">Submit Anyway</button>
    </div>
  </div>
</div>
